export const FeatureFlags = {
  DATADOG_RUM: 'datadog-rum',
  DATADOG_LOGS_FE: 'datadog-logs-fe',
  MULTI_LANGUAGE_SURVEY_FLAGS_OVERRIDES: 'multi-language.survey-flags-overrides',
  DISTRIBUTION_SLUG_REDIRECT: 'distribution-slug-redirect',
  // CLEANUP-L1S-1607: remove flag entry after 100% rollout stabilises
  SURVEY_LIGHTWEIGHT_ERROR_PROBE: 'survey-lightweight-error-probe',
  // CLEANUP-L1S-1606: remove flag entry after 100% rollout stabilises
  NEW_QUESTIONS_ENDPOINT: 'fe.survey-ui.new-questions-endpoint',
  // Numeric override of the page-transition fade (ms) for A/B testing; see useFadeTimeout.
  PAGE_TRANSITION_FADE_MS: 'fe.survey-ui.page-transition-fade-ms',
};
